import { type TranslationTree } from '@/i18n/types';

export const messages = {
  label: 'Campanha',
} satisfies TranslationTree;
